import React from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/Auth/auth";

export const PrivateRoute = ({ children }) => {
  let auth = AuthContext();
  return auth?.logIn ? children : <Navigate to={"/sell"} />;
};

export default PrivateRoute;
